



























import Decimal from '@/utils/decimal';
import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import Invoice from './Invoice.vue';

@Component
export default class InvoiceOrderAllowanceCharge extends Vue {
// eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop(Object) public allowanceCharge!: any;

  @Inject() public documentComponent!: Invoice;

  public get colspan() {
    let colspan = 7;
    if (this.documentComponent.displaySettings.invoiceLineOrderedQuantity) colspan += 1;
    if (this.documentComponent.displayLineAllowanceChargeColumn) colspan += 1;
    if (this.documentComponent.displaySettings.invoiceLineTaxAmount) colspan += 1;
    return colspan;
  }

  public get amount() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (this.allowanceCharge.orderAllowanceChargeLines as any[])
      .reduce((sum, line) => sum.add(line.amount), new Decimal(0));
  }
}
